import React from 'react';
import { ChevronUp, ChevronDown, ChevronsUpDown, Trash2 } from 'lucide-react';
import { Link2Icon, StarFilledIcon, StarIcon } from '@radix-ui/react-icons';
import productDefaultImg from '../../assets/product-default.png';
import serviceDefaultImg from '../../assets/service-default.png';

export default function ProductsTable({ items, onEdit, onToggleFavorite, onOpenFolio, onDelete, canEdit = true, sortField, sortOrder, onSort }) {
  const SortIcon = ({ active, order }) => {
    if (!active) return <ChevronsUpDown size={14} className="sort-icon" />;
    return order === 'asc' ? (
      <ChevronUp size={14} className="sort-icon active" />
    ) : (
      <ChevronDown size={14} className="sort-icon active" />
    );
  };

  return (
    <div className="overflow-x-auto">
      <table className="products-table min-w-full rounded-lg shadow-sm">
        <thead>
          <tr>
            <th>Image</th>
            <th onClick={() => onSort?.('name')}>
              Name <SortIcon active={sortField === 'name'} order={sortOrder} />
            </th>
            <th onClick={() => onSort?.('category')}>
              Category <SortIcon active={sortField === 'category'} order={sortOrder} />
            </th>
            <th onClick={() => onSort?.('vendorName')}>
              Vendor <SortIcon active={sortField === 'vendorName'} order={sortOrder} />
            </th>
            <th onClick={() => onSort?.('price')}>
              Trade Price <SortIcon active={sortField === 'price'} order={sortOrder} />
            </th>
            <th onClick={() => onSort?.('createdAt')}>
              Date Created <SortIcon active={sortField === 'createdAt'} order={sortOrder} />
            </th>
            <th>Link</th>
            <th>Folio</th>
            <th>Notes</th>
            {canEdit && <th>Delete</th>}
          </tr>
        </thead>

        <tbody>
          {items.map((item) => (
            <tr key={item.itemId} className={`border-t ${canEdit ? 'cursor-pointer' : ''}`} onClick={canEdit ? () => onEdit(item) : undefined}>
              <td>
                <div className="image-wrapper">
                  <img
                    src={item.imageUrl || item.image || item.thumbnailUrl || (item.type === 'service' ? serviceDefaultImg : productDefaultImg)}
                    alt={item.name}
                    className="thumbnail"
                    onError={(e) => {
                      e.currentTarget.src = item.type === 'service' ? serviceDefaultImg : productDefaultImg;
                    }}
                  />
                  <span
                    className="favorite-star"
                    onClick={(e) => {
                      e.stopPropagation();
                      onToggleFavorite(item.itemId, !item.isFavorite);
                    }}
                  >
                    {item.isFavorite ? (
                      <StarFilledIcon className="star-icon" />
                    ) : (
                      <StarIcon className="star-icon" />
                    )}
                  </span>
                </div>
              </td>

              <td>{item.name}</td>
              <td>{item.category || '—'}</td>
              <td>{item.vendorName || item.vendor || '—'}</td>
              <td>${Number(item.price || 0).toFixed(2)}</td>
              <td>{item.createdAt ? new Date(item.createdAt).toLocaleDateString() : '—'}</td>

              <td>
                {item.link ? (
                  <a
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Link2Icon className="link-icon" />
                  </a>
                ) : (
                  '—'
                )}
              </td>

              <td>
                <button
                  className="ps-icon-btn"
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    onOpenFolio?.(item);
                  }}
                >
                  <img
                    src="/folder-icon.png"
                    alt="Open folio"
                    className="link-icon"
                    width={18}
                    height={18}
                    draggable={false}
                  />
                </button>
              </td>

              <td className="truncate">{item.notes || ''}</td>

              {canEdit && (
                <td>
                  <button
                    className="ps-delete-btn"
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      onDelete?.(item);
                    }}
                    title="Delete item"
                  >
                    <Trash2 size={14} />
                    Delete
                  </button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
